export function isReferenceFreeGeneratedArtwork(record: Record<string, any>, checksum: string | null): boolean {
  const provenance = record?.generation_provenance;
  return !!checksum && record?.asset?.sha256 === checksum
    && typeof provenance?.provider === 'string' && provenance.provider.trim().length > 0
    && provenance.reference_images_used === false
    && Array.isArray(provenance.input_images) && provenance.input_images.length === 0
    && record?.source_art_exclusion?.source_illustrations_used === false
    && record?.source_art_exclusion?.modern_adaptation_references_used === false;
}
export function readableReviewError(message: string): string {
  return message.replace(/source_approval_missing_or_stale/g, 'Review the story’s source edition')
    .replace(/artwork_rights_approval_missing_or_stale/g, 'Confirm the artwork’s creation record')
    .replace(/artwork_approval_missing_or_stale/g, 'Review the artwork');
}
